export class BooleanHelper {
  private constructor() {}

  static invertTrueToNull(bool: boolean): boolean {
    return bool ? null : true;
  }

  // generalizing to an arbitrary amount of input booleans likely requires explicitly counting how many booleans are true
  static atLeastTwoOutOfThree(a: boolean, b: boolean, c: boolean): boolean {
    return a !== b ? c : a;
  }

  static xor(a: boolean, b: boolean): boolean {
    return (a || b) && !(a && b);
  }
}
